<div class="cart-dropdown">
  <div class="cart-dropdown__items">
    @for (item of items(); track $index) {
      <div class="cart-dropdown__item">
        <ntt-cart-item-row [item]="toViewModel(item)" />
      </div>
    }
  </div>

  <ntt-detail-row label="جمع هزینه پرداختی" class="cart-total-wrapper">
    <div class="cart-detail-row">
      <span class="cart-detail-row__label text-md-regular text-tertiary-hover"
        >مبلغ نهایی</span
      >
      <span class="cart-detail-row__value text-md-bold text-secondary-hover"
        >{{ totalPayableAmount() | nttAmount }} {{ currencyName() }}</span
      >
    </div>
  </ntt-detail-row>

  <button
    nttButton
    theme="solid"
    size="lg"
    class="cart-dropdown__checkout"
    routerLink="/basket"
    (click)="closeMenu()"
  >
    مشاهده سبد خرید
  </button>
</div>
